
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"cls-1",attrs:{"cx":"121.92","cy":"121.93","r":"120.42"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M208.58 38.3c-21.9 11.34-52.63 18.4-86.65 18.4s-64.75-7.05-86.65-18.4M35.14 205.42c21.88-11.26 52.5-18.26 86.38-18.26s65 7.11 86.92 18.54M1.5 121.93h240.85M121.92 1.5v240.85"}}),_c('ellipse',{staticClass:"cls-1",attrs:{"cx":"121.92","cy":"121.92","rx":"60.21","ry":"120.42"}})])
          )
        }
      }
    